export default {
  common: {
    login: '로그인',
    logout: '로그아웃',
    support: '지원',
    privacy: '개인정보보호정책',
    terms: `이용약관`,
    and: '및',
    guest: '손님',
    play: '플레이',
    install: '설치',
  },
  support: {
    title: `도움이 필요하세요?`,
    description: `저희 게임 유저로서 도움이 필요하시면
      저희가 정성껏 도와드리겠습니다.`,
    button: '@:common.support',
  },
  homescapes: {
    title: '꿈의 집',
    caption: '집사 오스틴을 도와 가족의 저택에 온기와 편안함을 되찾아주세요.',
    description: `집사 오스틴을 도와 가족의 저택에
      온기와 편안함을 되찾아주세요.
      문을 열고 들어오면 모험이 여러분을 맞이할 거예요!`,
  },
  cookie: {
    message: '여러분께서 웹사이트를 편하게 이용하실 수 있도록 쿠키를 사용하고 있습니다.',
    link: `더 알아보기`,
    button: '수락',
  },
  install: {
    title: '@:common.install',
    text: `이제 데스크톱에서도 꿈의 집을 플레이할 수 있어요!
    웹 버전 게임을 설치하고 오스틴을 방문하세요!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla는 꿈의 집 공인 글로벌 유통사입니다',
  },
  game: {
    notSupported: `모바일 기기는 지원하지 않습니다. 컴퓨터에서 로그인하여 플레이하세요.`,
  },
};
